import { type ButtonHTMLAttributes, type ReactNode } from "react";

import css from "./button.module.scss";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
};

export function Button({ children, ...props }: ButtonProps) {
  return (
    <button className={css.root} {...props}>
      <span className={css.content}>{children}</span>
    </button>
  );
}
